import {
    CreditType,
    GetTotemCashHistoryQueryResult,
    OrganizationCardState,
    WalletFragmentFragment,
} from 'data/__generated__';
import { PaymentMethodType } from './types';

import { DetailValue } from 'components/DetailsView';
import { TotemLabel } from 'components/TotemLabel';
import { CardAndMealVoucherPaymentMethods } from 'pages/Users/components/CardAndMealVoucherPaymentMethods';
import { Credits } from 'pages/Users/components/Credits';
import { Subventions } from 'pages/Users/components/Subventions';
import { TotemCashHistory } from 'pages/Users/components/TotemCashHistory';
import { WalletBalance } from 'pages/Users/components/WalletBalance';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export function PaymentMethods({
    userId,
    wallet,
    getTotemCashHistoryResult,
}: {
    userId: string;
    wallet: WalletFragmentFragment;
    getTotemCashHistoryResult: GetTotemCashHistoryQueryResult;
}) {
    const { creditCards, mealVouchers, subventions, credits, organizationCard } = wallet;
    const { data } = getTotemCashHistoryResult;
    const paymentMethods: PaymentMethodType[] = [...(creditCards || []), ...(mealVouchers || [])];
    return (
        <>
            <WalletBalance credits={credits} />

            <TotemLabel>Moyens de paiement</TotemLabel>

            {organizationCard ? (
                <DetailValue
                    label="Carte organisation"
                    value={organizationCard.state === OrganizationCardState.Active ? 'Active' : 'Archivée'}
                />
            ) : null}

            <TablesGrid>
                {subventions && subventions.length > 0 ? (
                    <GridCell>
                        <TotemLabel>Subventions</TotemLabel>
                        <Subventions subventions={subventions} />
                    </GridCell>
                ) : null}

                {credits ? (
                    <GridCell>
                        <TotemLabel>Crédits Actifs (dont Totem Cash)</TotemLabel>
                        <Credits credits={credits} />
                    </GridCell>
                ) : null}

                {data?.totemCashHistory ? (
                    <GridCell>
                        <TotemLabel>
                            Historique Totem Cash (5 dernières recharges,{' '}
                            <SeeMoreLink to={`/credits?userId=${userId}&type=${CreditType.Cash}`}>
                                voir plus
                            </SeeMoreLink>
                            )
                        </TotemLabel>
                        <TotemCashHistory totemCashHistory={data.totemCashHistory} />
                    </GridCell>
                ) : null}

                <GridCell>
                    <TotemLabel>Cartes Bancaires et Titres Restaurants</TotemLabel>
                    <CardAndMealVoucherPaymentMethods paymentMethods={paymentMethods} />
                </GridCell>
            </TablesGrid>
        </>
    );
}

const TablesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    margin-top: 8px;
`;

const GridCell = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

const SeeMoreLink = styled(Link)`
    text-transform: lowercase;
    color: ${({ theme }) => theme.textColor};
`;
